import { render } from "./SalesDeliveryNotes.vue?vue&type=template&id=b6468a84&scoped=true"
import script from "./SalesDeliveryNotes.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryNotes.vue?vue&type=script&lang=js"

import "./SalesDeliveryNotes.vue?vue&type=style&index=0&id=b6468a84&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6468a84"]])

export default __exports__